<template>
  <div>
    <ul class="list-unstyled test-campaigns-list" v-if="list">
      <box tag="li" v-for="(item, index) in list" :key="index">
        <bounty-campaign :campaign="item">
          <slot name="campaign" :campaign="item"></slot>
        </bounty-campaign>
      </box>
    </ul>
  </div>
</template>

<script>
import BountyCampaign from '@/components/BountyCampaign/BountyCampaign.vue';

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    BountyCampaign
  }
};
</script>
